import { Stack, styled, Typography } from '@mui/material';
import clsx from 'clsx';
import Link from 'next/link';

import useFormat from '../../../../hooks/useFormat';

const SectionTitle = styled(Typography)(({ theme: { palette } }) => ({
	color: palette.grey[600],
	fontSize: '12px',

	'&:not(.isMobileFormat)': {
		fontWeight: 400,
		fontSize: '0.875rem',
		color: palette.grey[500],
	},
}));

const SectionContent = styled(Typography)({
	fontSize: '18px',

	'&:not(.isMobileFormat)': {
		fontSize: '0.875rem',
	},
});

const SectionContentWithLink = styled(Typography)({
	fontSize: '18px',
	textDecoration: 'underline',
	cursor: 'pointer',

	'&:not(.isMobileFormat)': {
		fontSize: '0.875rem',
	},
});

type ContactInfosSectionProps = {
	label: string;
	value?: string;
	link?: string;
};

const ContactInfosSection = ({ label, value, link }: ContactInfosSectionProps) => {
	const { isMobileFormat } = useFormat();

	return (
		<Stack>
			<SectionTitle className={clsx({ isMobileFormat })}>{label}</SectionTitle>

			{link && value ? (
				<Link href={link}>
					<SectionContentWithLink className={clsx({ isMobileFormat })}>{value}</SectionContentWithLink>
				</Link>
			) : (
				<SectionContent className={clsx({ isMobileFormat })} fontStyle={value ? 'inherit' : 'italic'}>
					{value || 'Non renseigné'}
				</SectionContent>
			)}
		</Stack>
	);
};

export default ContactInfosSection;
